import { Component, OnInit, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-search-section-item',
    templateUrl: './search-section-item.component.html',
    styleUrls: ['./search-section-item.component.css']
})
export class SearchSectionItemComponent implements OnInit {
    @Input() title: string;
    @Input() template: TemplateRef<any>;

    constructor() { }

    ngOnInit() {
    }
}
